export type LoadingStatus = "LOADING" | "LOADED" | "REFRESHING" | "ERROR";

export const LOADING: LoadingStatus = "LOADING";
export const LOADED: LoadingStatus = "LOADED";
export const REFRESHING: LoadingStatus = "REFRESHING";
export const ERROR: LoadingStatus = "ERROR";
